import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import qs from 'qs';
import mixpanel from 'utils/mixpanelService';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import { setCookie, getCookie } from 'utils/cookieStore';
import {
  getClientDetails,
  setRegion,
  updateBrand,
  clearClientDetails,
} from 'containers/Main/actions';
import { clearLandingInfo } from 'containers/ClientLanding/actions';
import { makeSelectProfile } from 'containers/Auth/selectors';

const withPageBranding = Component => props => {
  const patchedBrand = useRef();
  const clientDetailsFetched = useRef();
  const history = useHistory();
  const location = useLocation();
  const profile = useSelector(makeSelectProfile());
  const { search, pathname } = location;
  const searchObject = qs.parse(search, {
    ignoreQueryPrefix: true,
  });
  const dispatch = useDispatch();

  useEffect(() => {
    if (!_isEmpty(_get(searchObject, 'brand'))) {
      const { brand } = searchObject;
      setCookie('brand', brand, {
        expires: 365,
      });
      mixpanel.init(brand);
      if (brand && brand !== 'none') {
        dispatch(clearLandingInfo());
        dispatch(getClientDetails(brand));
        clientDetailsFetched.current = brand;
      } else {
        dispatch(clearLandingInfo());
        dispatch(clearClientDetails());
        clientDetailsFetched.current = 'none';
      }

      dispatch(setRegion(''));
      localStorage.removeItem('region');
    } else {
      const brand = getCookie('brand');
      if (brand && brand !== 'none') {
        dispatch(getClientDetails(!brand ? 'none' : brand));
        clientDetailsFetched.current = !brand ? 'none' : brand;
      } else {
        dispatch(clearClientDetails());
        clientDetailsFetched.current = 'none';
      }
    }
    if (_get(window, 'xprops.client', false)) {
      const {
        xprops: { client },
      } = window;
      setCookie('brand', client, {
        expires: 365,
      });
      mixpanel.init(client);
      dispatch(clearLandingInfo());
      dispatch(getClientDetails(client));
      clientDetailsFetched.current = client;
    }
  }, []);

  useEffect(() => {
    if (profile.isLoaded && _isEmpty(_get(window, 'xprops.client'))) {
      if (!_isEmpty(_get(searchObject, 'brand'))) {
        const { brand, ...params } = searchObject;

        if (
          !profile.isEmpty &&
          patchedBrand.current !== brand &&
          profile.brand !== brand
        ) {
          patchedBrand.current = brand;
          dispatch(updateBrand({ brand, email: profile.email }));
        }

        history.replace(
          `${pathname}${!_isEmpty(params) ? `?${qs.stringify(params)}` : ''}`,
        );
      } else if (
        !profile.isEmpty &&
        profile.brand !== clientDetailsFetched.current
      ) {
        const cookieBrand = getCookie('brand');
        if (cookieBrand !== profile.brand) {
          setCookie('brand', profile.brand, { expires: 365 });
        }
        if (profile.brand && profile.brand !== 'none') {
          dispatch(getClientDetails(!profile.brand ? 'none' : profile.brand));
          clientDetailsFetched.current = !profile.brand
            ? 'none'
            : profile.brand;
        } else {
          dispatch(clearClientDetails());
          clientDetailsFetched.current = 'none';
        }
      } else if (!clientDetailsFetched.current) {
        const brand = getCookie('brand');
        if (brand && brand !== 'none') {
          dispatch(getClientDetails(!brand ? 'none' : brand));
          clientDetailsFetched.current = !brand ? 'none' : brand;
        } else {
          dispatch(clearClientDetails());
          clientDetailsFetched.current = 'none';
        }
      }
    }
  }, [profile]);

  return <Component {...props} />;
};

export default withPageBranding;
